/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 23,
  image: "default-changelog-v2.png",
  title: "Changelog Notes - V3.3.3-beta Patch 1",
  shortDescription: "We've shipped a few patches for the application based on user feedback and bugs encountered in the previous release.",
  description: "We've shipped a few patches for the application based on user feedback and bugs encountered in the previous release.",
  date: "Mar 9th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Fixes", "Patch", "Images", "Spheron Storage API", "Compute", "Next.js", "Cluster Instance", "Improvements"]
};
export const content = ` 
## Fixes & Improvements 🛠

- Resolved the problem where the loaders were stuck in an infinite spin loop on the Plan Usage page.
- Fixed the bug where the Load More button was not displayed when choosing a cluster instance plan.
- Updated the next.js automation logic to add
  \`\`\`
  {
  images: { unoptimized: true }
  }
  \`\`\`
  to the images option in the next.config.js instead of
  \`\`\`
  {
  images: { loader: "akamai", path: "" }
  }
  \`\`\`
- Fixed the issue that the max payload size was not working for parallel uploads for **Spheron Storage API**.
- We have resolved the issue that the selected region was not considered when deploying a Cluster Instance from the Marketplace template.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
